var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ style: _vm.containerStyle }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c("icon-svg", {
        attrs: {
          name: _vm.icon,
          color: _vm.iconColorResolved,
          size: _vm.iconSize
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }